import { DeleteOutlined, PoweroffOutlined } from "@ant-design/icons";
import { Button, message, Modal, Table, Tag } from "antd";
import { ColumnType } from "antd/es/table";
import { useEffect, useState } from "react";
import { IikoRole } from "../../features/integration-setting-table/RolesTable/role.type";
import { useLazyGetZupDepartmentsQuery, useRemoveZupDepartmentMutation, useUpdateZupDepartmentMutation } from "../../store/api/departmentApi";
import { BaseDepartment, } from "../../features/integration-setting-table/DepartmentsTable/department.type";

export const OneCZupDepartmentPage = () => {
    const [getIikoRoles, { data, isLoading }] = useLazyGetZupDepartmentsQuery();
    const [removeIikoRole] = useRemoveZupDepartmentMutation();
    const [updateZupDepartment] = useUpdateZupDepartmentMutation();
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
    });

    useEffect(() => {
        getIikoRoles({});
    }, []);

    const getColumnSearchProps = (dataIndex: string) => ({
        filterSearch: true,
        onFilter: (value: string, record: any) => record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
        filterMultiple: false,
        filters: data?.data?.map((item: any) => ({
            text: item[dataIndex],
            value: item[dataIndex],
        })) || [],
    });

    const handleDelete = (id: string) => {
        Modal.confirm({
            title: 'Вы уверены, что хотите удалить эту роль?',
            content: 'Это действие нельзя отменить.',
            okText: 'Да',
            okType: 'danger',
            cancelText: 'Нет',
            onOk: async () => {
                try {
                    await removeIikoRole(id).unwrap();
                    message.success('Департамент успешно удалена');
                    removeIikoRole(id);
                } catch (error) {
                    message.error('Не удалось удалить департамент');
                }
            },
        });
    };

    const handleEnable = async (id: string) => {
        Modal.confirm({
            title: 'Вы уверены, что хотите активировать этот департамент?',
            content: 'После активации департамент будет доступен в системе.',
            okText: 'Да',
            okType: 'primary',
            cancelText: 'Нет',
            onOk: async () => {
                try {
                    await updateZupDepartment(id).unwrap();
                    message.success('Департамент успешно активирован');
                    getIikoRoles({});
                } catch (error) {
                    message.error('Не удалось активировать департамент');
                }
            },
        });
    };

    const columns = [
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
            ...getColumnSearchProps('name'),
        },
        {
            title: 'Статус',
            dataIndex: 'enabled',
            key: 'enabled',
            render: (enabled: boolean) => (
                <Tag color={enabled ? 'green' : 'red'}>
                    {enabled ? 'Включен' : 'Отключен'}
                </Tag>
            ),
        },
        {
            title: 'Действия',
            key: 'actions',
            render: (_: any, record: IikoRole) => (
                record.enabled ? (
                    <Button
                        icon={<DeleteOutlined />}
                        danger
                        onClick={() => handleDelete(record.id)}
                    />
                ) : (
                    <Button
                        icon={<PoweroffOutlined />}
                        type="primary"
                        onClick={() => handleEnable(record.id)}
                    />
                )
            ),
        },
    ];

    const handleTableChange = (newPagination: any) => {
        setPagination(newPagination);
    };

    return (
        <div>
            <h1>Департаменты 1c ZUP</h1>
            <Table
                bordered
                columns={columns as ColumnType<BaseDepartment>[]}
                dataSource={data?.data}
                loading={isLoading}
                pagination={pagination}
                onChange={handleTableChange}
                rowKey="id"
            />
        </div>
    );
};
